<template>
  <div class="p-2">
    <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="k_rapports_datatable">
      <thead>
        <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
          <th class="min-w-300px text-center">{{ $t('reports.table.title') }}</th>
          <th class="min-w-100px text-center">{{ $t('reports.table.category') }}</th>
          <th class="min-w-100px text-center">{{ $t('reports.table.contact') }} </th>
          <th class="min-w-100px text-center">{{ $t('reports.table.manager') }} </th>
          <th class="min-w-100px text-center">{{ $t('reports.table.progress') }} </th>
          <th class="min-w-50px text-center">{{ $t('reports.table.steps') }} </th>
          <th class="min-w-50px text-center">{{ $t('reports.table.tasks') }} </th>
          <th class="min-w-50px text-center">{{ $t('reports.table.reviewedBeReview') }} </th>
          <th class="min-w-50px text-center">{{ $t('label.action') }}</th>
        </tr>
      </thead>
    </table>
  </div>
  <ReportModal id="report_detail_modal_2"  :report="current" :getting="getting" @load="loadProjectSelected"/>

</template>
<script setup>
  import {nextTick, onMounted, ref, watch, defineProps} from "vue";
  import {useRoute, useRouter} from "vue-router";
  import {useStore} from "vuex";
  import {useLocales} from "@/composables/locales";
  import {useSwal} from "@/composables/useSwal";
  import {BASE_URL} from "@/services/api";
  import {Theme} from "@/composables/theming";
  import { useI18n } from 'vue-i18n'
  import Ls from "@/services/ls";
  import {useHasAbility} from "@/composables/hasAbility";
  import ReportModal from './ReportModal.vue';
  import { useModelViewType } from "@/composables/modelViewType";

  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const {locale, datatableLocaleUrl} = useLocales()
  const {showSwal} = useSwal()
  const { t } = useI18n({ useScope: 'global' })
  const { can } = useHasAbility()
  const { modelViewType } = useModelViewType()

  const emits = defineEmits(['reloadDatatable'])

  const props = defineProps({
    filter: {
      type: Object,
      required: true
    },
    keyNumber: String,
    action: {
      type: Boolean,
      required: true
    },
  })

  const table = ref(null)
  const getting = ref(false)
  const current = ref('')
  const filterList = ref({
    status: '',
    start: 0,
    pageLength: 10
  })


  watch(() => locale.value, (value) => {
    nextTick(() => {
      fetchDatas()
    })
  }, { deep: true })

  

  watch(() => [props.filter], () => {
    if(table.value ){
      table.value?.ajax?.url(`${BASE_URL}/get/projects/rapport/stats/datatable?search=${props.filter.search}&status=${retrieveData(props.filter.status)}&startDate=${props.filter.start_date}&endDate=${props.filter.end_date}&project_category_id=${props.filter.project_category_id}&contact_id=${props.filter.contact_id}&user_id=${props.filter.user_id}`).load()
    }else{
      fetchDatas
    }
  },{ deep :true})

  watch(() => props.filter.reload, (value, oldValue) => {
    if(value > oldValue){
      table.value?.ajax?.url(`${BASE_URL}/get/projects/rapport/stats/datatable?search=${props.filter.search}&status=${retrieveData(props.filter.status)}&startDate=${props.filter.start_date}&endDate=${props.filter.end_date}&project_category_id=${props.filter.project_category_id}&contact_id=${props.filter.contact_id}&user_id=${props.filter.user_id}`).load()
    }
  })


  function fetchDatas() {
    const AUTH_TOKEN = Ls.get('auth.token')
    const pageLimit = Ls.get('pageLength')
    
    table.value = $("#k_rapports_datatable").DataTable({
      destroy: true,
      searching: false,
      responsive: !0,
      searchDelay: 500,
      processing: !0,
      serverSide: !0,
      pageLength: filterList.value.pageLength || pageLimit,
      lengthMenu: [5, 10, 25, 50, 75, 100 ],
      order: [[ 0, 'desc']],
      displayStart: filterList.value.start,
      ajax: {
        url: BASE_URL + `/get/projects/rapport/stats/datatable?search=${props.filter.search}&status=${retrieveData(props.filter.status)}&startDate=${props.filter.start_date}&endDate=${props.filter.end_date}&project_category_id=${props.filter.project_category_id}&contact_id=${props.filter.contact_id}&user_id=${props.filter.user_id}`,
        type: "GET",
        data: function(d) {
          delete d.search;
          d.search = props.filter.search;
        },
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          request.setRequestHeader("Company", Ls.get('current.company'));
        },
        complete: function (request) {
          if(request.status === 200) {
            request.responseJSON.start
            request.responseJSON.pageLength
            if (request.responseJSON && request.responseJSON.start) {
              filterList.value.start = request.responseJSON.start;
            }
            if (request.responseJSON && request.responseJSON.pageLength) {
              filterList.value.pageLength = request.responseJSON.pageLength; 
            }
          }

        }
      },
      columns: [
      { data: "title" }, { data: "category" }, { data: "contact" }, { data: "manager" }, { data: "progress" }, { data: "totalStep" }, { data: "totalTask" }, { data: "total_task_need_review" }, { data: "Actions", responsivePriority: -1 }
      ],
      columnDefs: [
         {
          targets: -9,
          order: "desc",
          className: "dt-start text-start clickable" ,
          render: function (t, a, e, l) {
            let ref = sanitize(e.reference) ? e.reference : ''
            return '<span data-id="'+ e.id +'">' + 
             '<a href="#" class="text-dark fw-bolder text-hover-primary mb-1 fs-6">'+e.title+'</a>' +
             '<span class="text-muted fw-bold d-block">'+e.reference+'</span>'												
              + "</span>";
          },
        },
        {
          targets: -8,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          },
        },
        {
          targets: -7,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            let contact = e.contact?.length > 0 ? e.contact[0]?.contact_name : ''
            return '<span data-id="'+ e.id +'">' + contact + "</span>";
          },
        },
        {
          targets: -6,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span data-id="'+ e.id +'">' + t + "</span>";
          },
        },
        {
          targets: -5,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span class="me-3 fs-4 text-'+ e.status?.color +'">' + e?.status?.[locale.value] + ' ('+ e.progress + '%)' + "</span>";
          },
        },
        {
          targets: -4,
          orderable: false,
          className: "dt-center text-center clickable" ,
          render: function (t, a, e, l) {
            return '<span class="badge badge-square border border-gray-300 p-2 badge-light-primary  me-2">'+e.completedSteps+'/' +e.totalStep+'</span>'
          },
        },
        {
          targets: -3,
          orderable: false,
          className: "dt-center text-center" ,
          render: function (t, a, e, l) {
            return '<span class="badge badge-square border border-gray-300 p-2 badge-light-primary  me-2">'+e.taskDone+'/' +e.totalTask+'</span>'
          },
        },
        {
          targets: -2,
          orderable: false,
          className: "dt-center text-center" ,
          render: function (t, a, e, l) {
            return '<span class="badge badge-square border border-gray-300 p-2 badge-light-primary" title="'+ i18n.global.t('tasks.label.reviewedBeReview') +'"> <img class="h-15px me-2" src="/assets/media/tasks/validate.png">'+e.total_task_reviewed+'/' +e.total_task_need_review+'</span>'
          },
        },
        {
          width: "10%",
          targets: -1,
          "className": "dt-center text-center",
          title: "Actions",
          orderable: !1,
          render: function (t, a, e, l) {
            let render = ""
            render+='<a href="javascript:;" data-id="'+ e.id +'"  class="btn btn-sm btn-clean btn-icon show_btn" title="'+ i18n.global.t('button.view') +'"><i  data-id="'+ e.id +'" class="fas fa-eye fs-2" style="color: '+Theme.gray +'"></i></a>'
            return render
          },
        },

      ],
      language: {
        url: datatableLocaleUrl.value,
      }
    });

    table.value.on("click", ".show_btn", (e) => {
      const target = e.target.closest('.show_btn');
      const id = target.getAttribute('data-id')
      handleProjectSelected(id)
    });
   
  }

  function sanitize(data){
    if( !data || data == 'null'){ 
      return ''
    }
    
    return data
  }

  function retrieveData(data) {
    return data === 'all' ? '' : data
  }

const handleProjectSelected = (id) => {
  try {
    getting.value = true
    store.dispatch('projects/getProject', {
      id : id,
      user_id :  props.filter.user_id
    })
    .then((res) => {
      current.value = res.data
      $('#report_detail_modal_2').modal('toggle')
    }).finally(() => getting.value = false)
  } catch (error) {
    getting.value = false
  }
}

const loadProjectSelected = (id) => {
   try {
    getting.value = true
    store.dispatch('projects/getProject', {
      id : id,
      user_id :  props.filter.user_id
    })
    .then((res) => {
      current.value = res.data
    }).finally(() => getting.value = false)
  } catch (error) {
    getting.value = false
  }

}


  onMounted(() => {
    fetchDatas()
  })
</script>